export function findDuplicateFileNames(array1: File[], array2: File[]) {
    return array1.some((fileObj1) => {
        return array2.some((fileObj2) => fileObj1.name === fileObj2.name);
    });
}
